import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  Wifi, 
  PcDisplay, 
  HddNetwork, 
  Tools, 
  Server, 
  CodeSlash, 
  ArrowRight,
  ChevronDoubleDown,
  Coin,
  GraphUp,
  ChevronDoubleUp
} from "react-bootstrap-icons";
import "../styles/home.css";

const NetworkVisual = () => {
  return (
    <div className="network-visual">
      <div className="node node-1"></div>
      <div className="node node-2"></div>
      <div className="node node-3"></div>
      <div className="node node-4"></div>
      <div className="node node-5"></div>
      <div className="connection connection-1"></div>
      <div className="connection connection-2"></div>
      <div className="connection connection-3"></div>
    </div>
  );
};

const Home = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeService, setActiveService] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setIsVisible(true);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Trigger animation after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToServices = () => {
    const servicesSection = document.querySelector('.section-light');
    servicesSection.scrollIntoView({ behavior: 'smooth' });
  };

  const services = [
    { 
      id: 1, 
      title: "Installation Réseau", 
      icon: Wifi, 
      color: "#ff0000", // Red from logo
      description: "Conception et déploiement d'infrastructures réseau performantes et sécurisées pour votre entreprise."
    },
    { 
      id: 2, 
      title: "Vente d'Équipement", 
      icon: PcDisplay, 
      color: "#ff7f00", // Orange from logo
      description: "Équipements informatiques de qualité professionnelle pour tous vos besoins avec service de conseil personnalisé."
    },
    { 
      id: 3, 
      title: "Solutions Réseau", 
      icon: HddNetwork, 
      color: "#0073b7", // Blue from logo
      description: "Solutions réseau personnalisées pour optimiser votre connectivité et améliorer les performances de votre infrastructure."
    },
    { 
      id: 4, 
      title: "Maintenance", 
      icon: Tools, 
      color: "#2a2a2a", // Black from logo
      description: "Maintenance préventive et corrective pour garantir la continuité de service et minimiser les temps d'arrêt."
    },
    { 
      id: 5, 
      title: "Serveurs & Stockage", 
      icon: Server, 
      color: "#ff0000", // Red from logo
      description: "Solutions de stockage et serveurs haute performance pour votre entreprise avec options de redondance et sauvegarde."
    },
    { 
      id: 6, 
      title: "Logiciels Sur Mesure", 
      icon: CodeSlash, 
      color: "#0073b7", // Blue from logo
      description: "Développement de logiciels adaptés à vos processus métiers et intégration avec vos systèmes existants."
    }
  ];

  // Features for the "Pourquoi Choisir SARL Agora Global" section
  const features = [
    {
      id: 1,
      title: "Prix Compétitifs",
      icon: Coin,
      color: "#ff0000", // Red from services
      description: "Des solutions IT haut de gamme à des prix abordables pour toutes les entreprises."
    },
    {
      id: 2,
      title: "Infrastructure Performante",
      icon: Server,
      color: "#0073b7", // Blue from services
      description: "Des serveurs et réseaux optimisés pour une productivité maximale."
    },
    {
      id: 3,
      title: "Logiciels Sur Mesure",
      icon: CodeSlash,
      color: "#0073b7", // Blue from services
      description: "Des solutions logicielles personnalisées pour répondre à vos besoins spécifiques."
    },
    {
      id: 4,
      title: "Produits Nouveaux",
      icon: PcDisplay,
      color: "#ff7f00", // Orange from services
      description: "Nous proposons les produits les plus récents et innovants du marché."
    },
    {
      id: 5,
      title: "Rapidité et Efficacité",
      icon: Wifi,
      color: "#ff0000", // Red from services
      description: "Des solutions rapides à déployer pour répondre à vos besoins immédiats."
    },
    {
      id: 6,
      title: "Solutions Scalables",
      icon: GraphUp,
      color: "#0073b7", // Blue from services
      description: "Des systèmes évolutifs qui grandissent avec votre entreprise."
    }
  ];

  // Partners list - doubled for continuous scrolling effect
  const partners = [
    "cisco", "hp", "dell", "microsoft", "ibm", "oracle", "intel", "samsung", 
    "lenovo", "vmware", "juniper", "fortinet", "aruba", "netapp", "redhat", 
    "ubuntu", "aws"
  ];
  
  const duplicatedPartners = [...partners, ...partners];

  return (
    <div className="modern-home">
      {/* Hero Section */}
      <section className="hero-section ">
        <NetworkVisual />
        <div className="container">
          <div className="row ">
            <div className={`col-lg-6 hero-content ${isVisible ? 'fade-in-left' : ''}`}>
<h1 className="">
  <span className="main-line">Solutions Technologiques</span>
  <span className="highlight-line">Innovantes</span>
</h1>
              <p className="hero-description ">
                SARL Agora Global fournit des solutions IT complètes pour transformer votre infrastructure numérique et optimiser vos performances.
              </p>
              <div className="btn-group">
                <Link to="/products" className="btn btn-primary">
                  Explorer nos produits <ArrowRight />
                </Link>
                <Link to="/about" className="btn btn-secondary">
                  A propos de nous <ArrowRight />
                </Link>
              </div>
            </div>
            <div className={`col-lg-6 ${isVisible ? 'fade-in-right' : ''}`}>
              <div className="hero-image">
                <img 
                  src={`${process.env.PUBLIC_URL}/images/Logo.png`} 
                  alt="Agora Global Solutions" 
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="scroll-indicator">
            <button onClick={scrollToServices} className="scroll-down-btn">
              <ChevronDoubleDown size={20} />
            </button>
          </div>
        </div>
      </section>

      {/* Features Section - "Pourquoi Choisir SARL Agora Global" */}
      <section className="section section-light">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="section-title">Pourquoi Choisir SARL Agora Global ?</h2>
            <p className="section-subtitle">
              Découvrez ce qui nous distingue dans le monde des solutions IT.
            </p>
          </div>
          <div className="services-grid">
            {features.map((feature) => (
              <div 
                key={feature.id} 
                className={`service-card`}
                style={{ '--service-color': feature.color }}
              >
                <div className="service-icon-container">
                  <feature.icon size={24} />
                </div>
                <h3 className="service-title">{feature.title}</h3>
                <p className="service-description">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section section-light">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nos Services</h2>
            <p className="section-subtitle">
              Des solutions sur mesure pour chaque besoin technologique de votre entreprise
            </p>
          </div>
          <div className="services-grid">
            {services.map((service) => (
              <div 
                key={service.id}
                className={`service-card ${activeService === service.id ? 'active' : ''}`}
                onMouseEnter={() => setActiveService(service.id)}
                onMouseLeave={() => setActiveService(null)}
                style={{ '--service-color': service.color }}
              >
                <div className="service-icon-container">
                  <service.icon size={24} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      

      {/* Partners Section - Auto-scrolling */}
      <section className="section partners-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nos Partenaires</h2>
            <p className="section-subtitle">
              Collaborant avec les leaders de l'industrie pour vous offrir les meilleures solutions
            </p>
          </div>
          <div className="partners-scroll-container">
            <div className="partners-track">
              {duplicatedPartners.map((partner, index) => (
                <div key={index} className="partner-logo">
                  <img 
                    src={`${process.env.PUBLIC_URL}/logos/logo${index % partners.length}.png`} 
                    alt={partner} 
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Scroll to top button */}
      {scrolled && (
        <button 
          className="scroll-down-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
           <ChevronDoubleUp size={20} />
        </button>
      )}
    </div>
  );
};

export default Home;